import { useState, useEffect } from "react";
import { getOnlineRegistration } from "../Service/Api";
// import "../Assets/css/Style.css";

function OnlineReg() {
  const [onlineRegData, setOnlineRegData] = useState(null);
  const [error, setError] = useState(null);
  const API_URL = "https://webapi.entab.info";

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getOnlineRegistration();
        console.log("Fetched data:", data);
        setOnlineRegData(data);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message || "Unknown error");
      }
    }
    fetchData();
  }, []);

  // 👉 Don't render anything if no data or empty array
  if (!onlineRegData || onlineRegData.length === 0) {
    return null;
  }

  return (
    <div className="online_reg">
      {onlineRegData.map((item, index) => (
        <div id="Registration-content" key={item?._id || index}>
          <a href={item.url || "#"} target="_blank" rel="noreferrer">
            <p>{item.title}</p>
          </a>

          {item.attachments && item.attachments.length > 0 && (
            <a
              href={`${API_URL}/api/image/${item.attachments[0]}`}
              target="_blank"
              rel="noreferrer"
              className="attachpdf">
              <i className="bi bi-paperclip"></i>
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export default OnlineReg;
